$(document).ready(function () {
    var EditTopicModal = $('#EditTopicModal');

    $('.edittopic-btn').on('click', function () {
        EditTopicModal.modal('show');
        var topic = $(this).parents('.topic-row').data('topic');
        $('span.topic').empty().append(topic.name);
        $('input[type="hidden"][name="id"]').val(topic.id);
        $('input[type="number"][name="reflection_max_words"]').val(topic.reflection_max_words);
        $('input[type="number"][name="caselearning_min_logs"]').val(topic.caselearning_min_logs);
        $('input[type="number"][name="caselearning_max_logs"]').val(topic.caselearning_max_logs);
        $('input[type="number"][name="caselearningpoints_max_words"]').val(topic.caselearningpoints_max_words);
        // Add content of intro_text to editable div to make visible in editor, and ensure it does not clear on save
        $('#EditTopicModal .note-editable').html(topic.intro_text);
        $('textarea[name="intro_text"]').val(topic.intro_text).summernote().on('summernote.change', function (we, contents) {
            $(this).val(contents);
        });
    });
});
